import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import '../blog/styles.scss'

export default function News({ news }) {
    const QueryNews = useStaticQuery(graphql`
    {
        allPrismicNews {
            nodes {
              data {
                linkall {
                    url
                }
              }
            }
          }
    }
    `)

    const noticias = QueryNews.allPrismicNews.nodes[0].data

    return (
        <section className='blog'>
            <div className='blog-content'>
                <div className='blog-header'>
                    <h2 className='blog-title'>
                        Noticias
                    </h2>
                    <a className='blog-viewall' href={process.env.URL_BASE_NEWS} target='_blank'>Ver todos</a>
                </div>
                <div className='blog-list'>
                    {news.map((item, index) => (
                        <div className='blog-item' key={`news-home-${index}`}>
                            <div className='blog-item-img'>
                                <img src={item.image} alt={item.image} />
                            </div>
                            <div className='blog-item-description'>
                                <h2>{item.title}</h2>
                                <div className='blog-item-description-footer'>
                                    <a href={`${process.env.URL_BASE_EDUKANDO_LABTICA_NEWS}${item.id}`} target='_blank' className='blog-item-description-btn'>
                                        <p>Leer más</p>
                                    </a>
                                    <p>{item.datecreated}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='blog-extra'>
                <h2 className='blog-title'>
                    Redes sociales
                </h2>
                <ul className='blog-extra-networks'>
                    <li>
                        <a href='https://www.instagram.com/yamahacolombia/?igshid=YmMyMTA2M2Y%3D' target="_blank">
                            <em className='fa-brands fa-instagram c-ins' />
                            <p>@yamahacolombia</p>
                        </a>
                    </li>
                    <li>
                        <a href='https://www.facebook.com/yamahamotorcolombia/' target="_blank">
                            <em className='fa-brands fa-facebook c-face' />
                            <p>Yamaha Motor Colombia</p>
                        </a>
                    </li>
                    <li>
                        <a href='https://youtube.com/c/YamahaMotorColombia' target="_blank">
                            <em className='fa-brands fa-youtube c-pint' />
                            <p>Yamaha Motor Colombia</p>
                        </a>
                    </li>
                    <li>
                        <a href='https://twitter.com/yamahacolombia?t=p-snj3yHnX369OHLEFktUw&s=08'target="_blank">
                            <em className='fa-brands fa-twitter c-tw' />
                            <p>Yamaha Motor Colombia</p>
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    )
}